import { render } from "./TermsView.vue?vue&type=template&id=456c7be2&ts=true"
import script from "./TermsView.vue?vue&type=script&lang=ts"
export * from "./TermsView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__